export function assert<T>(value: T, errorMessage: string): asserts value {
    if (value === undefined || value === null) {
        throw new Error(errorMessage)
    }
}
